// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  descriptionDisplayLength:'__descriptionDisplayLength__',
  cacheBusterHash: '__cacheBusterHash__',
  alleAuthConfig: {
    clientID: '__authClientID__',
    domain: '__authDomain__',
    scope: '__authScope__',
    responseType: 'token id_token',
    audience: '__authAudience__',
    redirectUri: '__authRedirectURI__',
    logoutUrl: '__logoutUrl__',
    inAppRedirects: {
      loggedIn: '/callback',
      error: '/error'
    },
  },
  auth0Claims: {
    roles: '__roles__',
    isCompanyManager: '__isCompanyManager__',
    userType: '__userType__'
  },
  apiUrl: '__apiUrl__',
  appDefaultImage: '__appDefaultImage__',
  signupUrl: '__signupUrl__',
  profile:  '__profileUrl__',
  appInsightsInstrumentationKey: '__appInsightsKey__',
  internalOnly: '__internalOnly__',
  groupsUrl: '__groupsUrl__',
  baseHref: '__baseHref__', 
  helpDeskConfig:{
    supportTicketEndpoint: '__supportTicketEndpoint__',
    allowedExtensions : '__allowedExtensions__',
    attachmentCount: '__attachmentCount__',
    maxAttachmentSize: '__maxAttachmentSize__',
    maxDescriptionLength: '__maxDescriptionLength__',
    maxTitleLength: '__maxTitleLength__',
    resourceCenter: '__resourceCenter__'
  },
  usePermit:'__usePermit__',
  minimumSearchLength: '__minimumSearchLength__'
};
